module.exports = __webpack_public_path__ + "media/images/lb/700-3e2b02bd0f48fc5b0be9f6167d86dae3.svg";